import axios from 'axios'

// const isDev = process.env.REACT_APP_ENV === 'DEV'
// console.log('isDev', isDev)
const request = axios.create({
  // baseURL: isDev ? '/api' : process.env.REACT_APP_TELE_URL,
  baseURL: process.env.REACT_APP_TELE_URL,
})
const vestName = process.env.REACT_APP_VEST_NAME

// 添加响应拦截器
request.interceptors.response.use(
  (response) => {
    // 如果响应成功返回
    return response
  },
  (error) => {
    // 获取错误信息
    const errorMsg = error.response?.data?.message || 'Request failed, please try again later'

    // 处理401错误（token过期）
    if (error.response && (error.response.status === 401 || error.response.data?.code === 401)) {
      // 清空本地存储
      localStorage.clear()

      // 跳转到登录页面
      setTimeout(() => {
        window.location.href = '/login'
      }, 2000)

      return Promise.reject(new Error('Login expired, please login again'))
    }

    // 显示错误提示
    console.error('API Error:', errorMsg)

    // 统一错误格式，方便后续处理
    error.formattedError = { code: error.response?.data?.code || -1, msg: errorMsg }

    return Promise.reject(error)
  }
)

// 修改为函数，每次调用时获取最新值
const getHeaders = () => {
  const userInfo = JSON.parse(localStorage.getItem('user_info')) || {}
  const rawToken = userInfo.token + '-' + userInfo.id
  const token = btoa(rawToken)
  return { token }
}

const getUserId = () => {
  const userInfo = JSON.parse(localStorage.getItem('user_info')) || {}
  return userInfo.id || ''
}

// 统一处理请求结果和错误
const handleRequest = async (requestPromise) => {
  try {
    const { data } = await requestPromise
    return data
  } catch (error) {
    return error.formattedError || { code: -1, msg: 'Request failed, please try again later' }
  }
}

// 获取验证码
export const sendSms = (params) => {
  return handleRequest(request.post('/common/user/otp', { ...params, vestName }))
}

// 短信登录
export const smsLogin = (params) => {
  return handleRequest(request.post('/common/user/login', { ...params, vestName }))
}

// 获取商品列表
export const fetchProductList = (params) => {
  return handleRequest(request.post('/product/list', { ...params, vestName }))
}

// 获取商品详情
export const fetchProductDetail = (params) => {
  return handleRequest(request.post(`/product/detail`, params))
}

// 新增/编辑地址
export const addOrUpdateAddress = (params) => {
  return handleRequest(
    request.post(
      '/product/address/update',
      { ...params, userId: getUserId() },
      {
        headers: getHeaders(),
      }
    )
  )
}

// 获取地址详情
export const getAddressDetail = (params) => {
  return handleRequest(
    request.post(
      '/product/address/detail',
      { ...params, userId: getUserId() },
      {
        headers: getHeaders(),
      }
    )
  )
}

// 创建订单
export const createOrder = (params) => {
  return handleRequest(
    request.post(
      '/product/order/add',
      { ...params, userId: getUserId() },
      {
        headers: getHeaders(),
      }
    )
  )
}

// 获取订单列表
export const getOrderList = (params) => {
  return handleRequest(
    request.post(
      '/product/order/list',
      { ...params, userId: getUserId() },
      {
        headers: getHeaders(),
      }
    )
  )
}

// 删除订单
export const deleteOrder = (params) => {
  return handleRequest(
    request.post(
      '/product/order/delete',
      { ...params, userId: getUserId() },
      {
        headers: getHeaders(),
      }
    )
  )
}

// 添加某条购物车或心愿单商品
export const addCartOrWishOne = (params) => {
  return handleRequest(request.post('/product/cart/add', { ...params, userId: getUserId(), vestName }, { headers: getHeaders() }))
}

// 删除全部购物车或心愿单记录
export const deleteAllCartOrWishItem = (params) => {
  return handleRequest(request.post('/product/cart/deleteAll', { ...params, userId: getUserId(), vestName }, { headers: getHeaders() }))
}

// 删除某条购物车或心愿单记录
export const deleteCartOrWishItem = (params) => {
  return handleRequest(request.post('/product/cart/delete', { ...params, userId: getUserId(), vestName }, { headers: getHeaders() }))
}

// 查询购物车或心愿单记录
export const getCartOrWishList = (params) => {
  return handleRequest(request.post('/product/cart/list', { ...params, userId: getUserId(), vestName, pageNo: 1, pageSize: 1000 }, { headers: getHeaders() }))
}

// 更新某条购物车记录
export const updateCartItem = (params) => {
  return handleRequest(request.post('/product/cart/update', { ...params, userId: getUserId() }, { headers: getHeaders() }))
}

// 订单状态检查
export const queryOrderStatus = (params) => {
  return handleRequest(request.post('/common/order/check', params, { headers: getHeaders() }))
}

// 携带手机号新增或更新用户名
export const addOrUpdateUserName = async (params) => {
  const mixedParams = {
    ...params,
    vestName: process.env.REACT_APP_VEST_NAME,
  }
  const { data } = await request.post('/common/user/addOrUpdateUsername', { ...mixedParams, vestName })
  if (data?.data) {
    return data.data
  }
  return null
}
